import React from "react";

const OptinStatusInput = ({
  value,
  onChange,
  placeholder,
  autoFocus = false,
  onSelect,
}) => {
  const optinStatusOptions = [
    { key: "optin", label: "Optin" },
    { key: "neverOptin", label: "Never optin" },
    { key: "optout", label: "Optout" },
  ];

  const handleChange = (e) => {
    const selectedKey = e.target.value;
    const selectedOption = optinStatusOptions.find(
      (opt) => opt.key === selectedKey,
    );
    if (selectedOption) {
      onChange(selectedOption.label);
      // Auto-close the filter input when a selection is made
      if (onSelect) {
        onSelect(selectedOption.label);
      }
    }
  };

  const currentValue =
    optinStatusOptions.find((opt) => opt.label === value)?.key || "";

  return (
    <select
      value={currentValue}
      onChange={handleChange}
      placeholder={placeholder}
      autoFocus={autoFocus}
      className="px-3 py-1 border-0.5 border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-pink focus:border-transparent min-w-[120px]"
    >
      <option value="" disabled>
        {placeholder}
      </option>
      {optinStatusOptions.map((option) => (
        <option key={option.key} value={option.key}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default OptinStatusInput;
